import React, { useEffect, useState } from 'react';
import PaymentSettingsDialog from '../../PaymentSettings/PaymentSettingsDialog';
import Spinner from '../../Spinner/Spinner';
import Dialog from '../../Dialogs/Dialog';
import fecha from 'fecha';
import * as formatters from '../../../utils/formatters';
import PaymentFailureDialog from './PaymentFailureDialog';
import { api } from '../../../api/client';

const PaymentDialog = ({
    title,
    accountNumber,
    paymentAmount,
    user,
    isVisible,
    onClose,
    onPaymentSuccess,
    onPaymentFailed,
    isPaymentBeforeEnroll
}) => {
    const [isBusy, setIsBusy] = useState(false);
    const [showDialogPaymentSuccessful, setShowDialogPaymentSuccessful] = useState(false);
    // eslint-disable-next-line
    const [serverError, setServerError] = useState(null);
    const [paymentDetails, setPaymentDetails] = useState(null);
    const [isDisabledPayment, setIsDisabledPayment] = useState(false);
    const [editedAmount, setEditedAmount] = useState(null);
    const [showDialogPaymentFailed, setShowDialogPaymentFailed] = useState(false);
    const [hideFooter, setHideFooter] = useState(false);
    const [paymentFailureMessage, setPaymentFailureMessage] = useState(null);

    useEffect(() => {
        setEditedAmount(paymentAmount);
    }, [paymentAmount]);

    const onPaymentMethodChange = (paymentDetails) => {
        let disablePayment = paymentDetails == null;
        setPaymentDetails(paymentDetails);
        setIsDisabledPayment(disablePayment);
    };

    const makePayixPayment = async (accountNumber, paymentInfo) => {
        const url = `/payments/${accountNumber}/makePayment`;
        console.log(accountNumber, paymentInfo);

        setIsBusy(true);

        await api
            .post(url, paymentInfo)
            .then(function (response) {
                setIsBusy(false);
                setShowDialogPaymentSuccessful(true);
                setShowDialogPaymentFailed(false);
                if (typeof onPaymentSuccess === 'function') {
                    onPaymentSuccess(response);
                }
            })
            .catch(function (error) {
                setIsBusy(false);
                const message = parsePaymentErrorResponse(error);

                setPaymentFailureMessage(message);
                setShowDialogPaymentFailed(true);
                setShowDialogPaymentSuccessful(false);
                if (typeof onPaymentFailed === 'function') {
                    onPaymentFailed(error);
                }
                // setState({ serverError: message, paymentFailureMessage: message, showDialogPaymentFailed: true });
                //console.log(errorMessage);
            });
    };

    const parsePaymentErrorResponse = (error) => {
        let errorMessageData = error?.response?.data?.Message;
        let errorMessage = error.message ? error.message : 'Something went wrong';
        errorMessage = typeof errorMessageData !== 'undefined' ? errorMessageData : errorMessage;
        const message = `Payment attempt was not successful. Reason: ${errorMessage}. Please double-check the information entered or use a different payment method.`;
        return message;
    };

    const onAddPaymentMethod = (disablePayment, hideFooter) => {
        setIsDisabledPayment(disablePayment);
        setHideFooter(hideFooter);
    };

    const onClosePayDialog = async () => {
        // console.log(paymentDetails);

        // let accountNumber = selectedAccountNumber;
        let paymentInfo = {
            UserName: user?.unique_name, // props.CurrentUser.unique_name,
            // LeaseNumber omitted - payment is account-level, not lease-specific
            PaymentMethodName: paymentDetails.selectedPaymentMethod,
            PaymentType: paymentDetails.PaymentMethodId,
            Amount: editedAmount,
            Token: paymentDetails.Token,
        };

        await makePayixPayment(accountNumber, paymentInfo);
        setIsBusy(false);
        onClose();
    };

    const handlePayDialogCancel = () => {
        setIsDisabledPayment(true);
        setHideFooter(false);
        onClose();
        // setEditedAmount(null);
    };

    const serverErrorBlock = serverError !== '' ? <div className="errorMessage">{serverError}</div> : null;
    const spinner = isBusy ? <Spinner /> : null;
    const currentDateFormatted = fecha.format(new Date(), fecha.masks.shortDate);
    const paymentAmountFormatted = formatters.currency(editedAmount);

    const paymentSuccessfulDialogSelected = isPaymentBeforeEnroll ? (
        <Dialog
            onClose={() => setShowDialogPaymentSuccessful(false)}
            title="Payment was successful."
            show
            closeButton="false"
            closeButtonText="OK"
        >
            <p>
            Payment in the amount of {paymentAmountFormatted} was successful, and will be will be applied to your
            account on or after {currentDateFormatted}.
            </p>
            <p>
            You can enroll in Autopay starting the following day after your payment has been successfully applied.
            </p>
        </Dialog>
    ) : (
        <Dialog
            onClose={() => setShowDialogPaymentSuccessful(false)}
            title="Payment was successful."
            show
            closeButton="false"
            closeButtonText="OK"
        >
            Payment in the amount of {paymentAmountFormatted} was successful, and will be will be applied to your
            account on or after {currentDateFormatted}.
        </Dialog>
    );

    const paymentSuccessfulDialog = showDialogPaymentSuccessful ? paymentSuccessfulDialogSelected : null;
    const paymentFailureDialog = showDialogPaymentFailed ? (
        <PaymentFailureDialog onClose={() => setShowDialogPaymentFailed(false)} message={paymentFailureMessage} />
    ) : null;

    const payDialog = isVisible ? (
        <Dialog
            show
            showCancelButton
            allowDisable
            title={title}
            onClose={onClosePayDialog}
            onCancel={handlePayDialogCancel}
            customClass={'modal-dialog-extended'}
            isDisabled={isDisabledPayment}
            hideFooter={hideFooter}
            closeButtonText="Pay Now"
        >
            <>
                <PaymentSettingsDialog
                    paymentAmount={editedAmount}
                    onAmountChanged={(e) => setEditedAmount(e)}
                    amountBeforeEdit={paymentAmount}
                    onAddPaymentMethod={onAddPaymentMethod}
                    onMethodChange={onPaymentMethodChange}
                    accountnumber={accountNumber}
                />

                {hideFooter ? null : <div className="total-group"></div>}
                {/* <Json obj={props} /> */}
            </>
        </Dialog>
    ) : null;
    return (
        <>
            {payDialog}
            {paymentSuccessfulDialog}
            {paymentFailureDialog}
            {serverErrorBlock}
            {spinner}
        </>
    );
};

export default PaymentDialog;
